
import { ModalActionTypes } from './modal.actionTypes';

// export function showModal() {
//   return {
//     type: ModalActionTypes.ShowModal,
//     payload: true
//   }
// }

// export function hideModal() {
//   return {
//     type: ModalActionTypes.HideModal,
//     payload: false
//   };
//}//


export const closeSignupModalFunc = () => dispatch => {
  dispatch({ type: ModalActionTypes.HIDE_SIGNUP })
};
export const closeLoginModalFunc = () => dispatch => {
  dispatch({ type: ModalActionTypes.HIDE_LOGIN })
}
export const showLoginModalFunc = () => dispatch => {
  dispatch({ type: ModalActionTypes.SHOW_LOGIN })
}

export const showSignupModalFunc = () => dispatch => { dispatch({ type: ModalActionTypes.SHOW_SIGNUP }) }